import React from "react";
import "./styles.scss";
import PageHeader from "./header/PageHeader";
import SubSectionCard from "./subsection-card/SubsectionCard";
import { useWorkShop } from "../../../../../../contexts/workshop-context/WorkshopContext";
import {
  SubsectionStatus,
  useAppUser,
} from "../../../../../../contexts/user-context/UserContext";

interface IProps {
  isArchived: boolean;
}

const Summary = (props: IProps) => {
  const workshop = useWorkShop();
  const appUser = useAppUser();

  return (
    <div className="student-workshop-summary-wrapper">
      <PageHeader isArchived={props.isArchived} />
      <div className="workshop-summary-content">
        {workshop.workshopSections.map((sub, index) => (
          <SubSectionCard
            key={index}
            title={`${index + 1}. ${sub.subSectionTitle}`}
            disabled={
              !(
                appUser.workshopProgress &&
                appUser.workshopProgress.filter(
                  (w) => w.workshopId === workshop.id
                ).length > 0
              )
            }
            onClick={() => {
              if (
                appUser.workshopProgress &&
                appUser.workshopProgress.filter(
                  (w) => w.workshopId === workshop.id
                ).length > 0
              ) {
                workshop.setSelectedSubSection(sub);
              }
            }}
            status={
              sub.status === SubsectionStatus.DONE ? "Completed" : "Inprogress"
            }
          />
        ))}
      </div>
    </div>
  );
};

export default Summary;
